/** App-wide locale for date/number formatting. */
export const APP_LOCALE = "es-AR";
